// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"795ba2af","453":"8ab44547","677":"cba42c6c"}[chunkId] + ".chunk.js";
};